import React, { Fragment, useState, useEffect, useContext, useRef, useCallback } from "react";
import { useParams } from "react-router-dom";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import { styled } from "@mui/material/styles";
import { Paper } from "@mui/material";
import ClientLookup from "../customer/ClientLookup";
import AddFilingPostAwardtable from "./AddFilingPostAwardtable";
import ReactLoading from "react-loading";
import DeferredToolbox from "../dev/addfiling/DeferredToolbox";
import DeferredHistory from "../dev/addfiling/DeferredHistory";
import CustomDialog from "../common/CustomDialog";
import axios from "axios";
import { tokens } from "../../theme/tokens";
import DeferedCommentsPA from "./DeferedCommentsPA";
import { useNavigate } from "react-router-dom";
import { useCommonDetailsContext } from "../../context/Common/common";
import CustomerContext from "../../context/customer/CustomerContext";
const API_BASE_URL = process.env.REACT_APP_TRKNW_API_BASE_URL;
const POST_AWARD_DEFERRED_SELECTED_ROW_KEY = "postAwardDeferredSelectedRow";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

function AddFilingPostAwardlist(props) {
  const navigate = useNavigate();
  const { clientId } = useParams();
  const { publishedBranding, clientScopedBranding, setClientScopedBranding, validateParentData, fetchClientBranding } = useCommonDetailsContext();
  const customerContext = useContext(CustomerContext);
  const { customers, selectedCustomer } = customerContext || {};
  const [customerId, setCustomerId] = React.useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [loadingFlag, setLoadingFlag] = useState(false);
  const [selectedMasters, setSelectedMasters] = useState(null);
  const selectedMastersRef = useRef(null);
  const [showHistory, setShowHistory] = useState(false);
  const [activityHistory, setActivityHistory] = React.useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [comments, setComments] = useState([]);
  const [showComments, setShowComments] = useState(false);

  useEffect(() => {
    const targetId = customerId || clientId;
    if (!validateParentData?.isSingleParent && targetId && fetchClientBranding) {
      const customerList = customers || [];
      const selected = customerList.find((c) => String(c.customerId) === String(targetId)) || (String(selectedCustomer?.customerId) === String(targetId) ? selectedCustomer : null);
      const customerType = selected?.customerType || selected?.clientType;
      fetchClientBranding(targetId, customerType);
    } else if (!targetId && setClientScopedBranding) {
      setClientScopedBranding(null);
    }
  }, [customerId, clientId, validateParentData?.isSingleParent, fetchClientBranding, setClientScopedBranding, customers, selectedCustomer]);

  const handleSelectedMastersChange = useCallback((val) => {
    selectedMastersRef.current = val;
    setSelectedMasters(val);
  }, []);

  const getCurrentSelectedMaster = () => {
    if (selectedMastersRef.current) {
      return selectedMastersRef.current;
    }

    if (selectedMasters) {
      return selectedMasters;
    }

    try {
      const storedValue = sessionStorage.getItem(
        POST_AWARD_DEFERRED_SELECTED_ROW_KEY
      );
      return storedValue ? JSON.parse(storedValue) : null;
    } catch (error) {
      console.log("@@Error reading selected filing tracker record:", error);
      return null;
    }
  };

  const getCustomerId = (id) => {
    setCustomerId((prevCustomerId) => {
      if (prevCustomerId !== id) {
        selectedMastersRef.current = null;
        setSelectedMasters(null);
        setComments([]);
        setActivityHistory([]);
        setShowHistory(false);
        setShowComments(false);
        sessionStorage.removeItem(POST_AWARD_DEFERRED_SELECTED_ROW_KEY);
      }
      return id;
    });
  };

  const closeAlert = () => {
    setShowAlert(false);
  };

  const closeComments = () => {
    setShowComments(() => false);
  };

  const fetchClientTrackingHistory = async (filingId) => {
    try {
      const currentSelection = getCurrentSelectedMaster();
      const resolvedCustomerId =
        customerId ?? currentSelection?.customerId ?? clientId;

      setActivityHistory([]);

      const history = await axios.get(
        `${API_BASE_URL}/Customer/DeferredFilingAudit?CustomerId=${resolvedCustomerId}&FilingId=${filingId}`
      );
      setActivityHistory(() => history.data.data);
    } catch (error) {
      console.log("@@Error:", error);
    }
  };

  const getWorkflowIdsAndFileTrackingIds = () => {
    const currentSelection = getCurrentSelectedMaster();
    console.log("getWorkflowIdsAndFileTrackingIds", currentSelection);

    let fileTrackingIds = [];
    let workflowIds = [];

    if (currentSelection?.filetrackingID) {
      fileTrackingIds.push(currentSelection.filetrackingID);
    }

    if (currentSelection?.workflowId) {
      workflowIds.push(
        typeof currentSelection.workflowId === "object"
          ? currentSelection.workflowId.workflowId
          : currentSelection.workflowId
      );
    }

    if (Array.isArray(currentSelection?.filingPeriods)) {
      currentSelection.filingPeriods.forEach((period) => {
        if (Array.isArray(period.fileTrackingId) && period.fileTrackingId.length > 0) {
          fileTrackingIds.push(period.fileTrackingId[0].fileTrackingId);
        }

        if (period.workflowId) {
          workflowIds.push(
            typeof period.workflowId === "object"
              ? period.workflowId.workflowId
              : period.workflowId
          );
        }
      });
    }

    fileTrackingIds = [...new Set(fileTrackingIds.filter(Boolean))];
    workflowIds = [...new Set(workflowIds.filter(Boolean))];

    return { fileTrackingIds, workflowIds };
  };

  const fetchFilingMasterComments = async () => {
    const currentSelection = getCurrentSelectedMaster();
    const { fileTrackingIds, workflowIds } = getWorkflowIdsAndFileTrackingIds();

    try {
      let resByFileTrackingId;
      let resByWorkflowId;
      let resByFileTrackingIdAttachments;

      if (workflowIds.length > 0) {
        resByWorkflowId = await axios.get(
          `${API_BASE_URL}/Customer/CustomerFilingWorkflowComments${workflowIds[0]}`
        );
      }

      if (fileTrackingIds.length > 0) {
        const queryString = fileTrackingIds
          .map((id) => `fileTrackingIds=${id}`)
          .join("&");

        resByFileTrackingId = await axios.get(
          `${API_BASE_URL}/Customer/ViewChildCustomerFilingTrackingComments?${queryString}`
        );

        resByFileTrackingIdAttachments = await axios.get(
          `${API_BASE_URL}/Customer/ViewParentandchildCustomerCommentsandAttachments?customerIds=${currentSelection?.customerId}&${queryString}`
        );
      }

      const combinedResponse = [
        ...(resByFileTrackingId?.data?.length > 0 ? resByFileTrackingId.data : []),
        ...(resByFileTrackingIdAttachments?.data?.data?.length > 0
          ? resByFileTrackingIdAttachments.data.data
          : []),
        ...(resByWorkflowId?.data?.length > 0 ? resByWorkflowId.data : []),
      ];

      const uniqueResponse = combinedResponse.filter(
        (item, index, self) =>
          index === self.findIndex((t) => t.commentsId === item.commentsId)
      );

      uniqueResponse.sort((a, b) => {
        const dateA = new Date(a.updateDate || a.createDate);
        const dateB = new Date(b.updateDate || b.createDate);
        return dateB.getTime() - dateA.getTime();
      });

      setComments(() => uniqueResponse);
    } catch (error) {
      console.log("@@Error:", error);
    }
  };

  const addComment = () => {
    const currentSelection = getCurrentSelectedMaster();
    console.log("addComment selectedMasters:", currentSelection);
    if (currentSelection) {
      fetchFilingMasterComments();
      setShowComments(() => true);
    } else {
      console.log("addComment validation failed - selectedMasters:", currentSelection);
      setAlertMessage("Please Select a Filing Tracker Record");
      setShowAlert(true);
    }
  };

  const displayHistory = async () => {
    const currentSelection = getCurrentSelectedMaster();
    console.log("displayHistory selectedMasters:", currentSelection);
    if (currentSelection?.filingId) {
      setActivityHistory([]);
      fetchClientTrackingHistory(currentSelection.filingId);
      setShowHistory(() => true);
    } else {
      console.log("displayHistory validation failed - selectedMasters:", currentSelection);
      setAlertMessage("Please Select a Filing Tracker Record");
      setShowAlert(true);
    }
  };

  const closeHistory = () => {
    setActivityHistory([]);
    setShowHistory(() => false);
  };
  const displayClientFiling = () => {
    if (clientId) {
      navigate(`/client-filing-tracker-list/${clientId}`);
    } else {
      navigate("/client-filing-tracker-list");

    }
  };
  React.useEffect(() => {
    // console.log("props Test", props);
    setIsLoading(false);
  }, []);

  useEffect(() => {
    if (clientId) {
      setCustomerId(clientId);
    }
  }, [clientId]);

  useEffect(() => {
    return () => {
      setCustomerId(null);
      selectedMastersRef.current = null;
      setSelectedMasters(null);
      sessionStorage.removeItem(POST_AWARD_DEFERRED_SELECTED_ROW_KEY);
    };
  }, []);

  return (
    <Fragment>
      {isLoading ? (
        <ReactLoading
          style={{
            position: "absolute",
            width: "3rem",
            marginLeft: "36rem",
            marginTop: "10rem",
            color: "#0000FF",
          }}
          type="spin"
          color="blue"
          height={80}
        />
      ) : (
        <Fragment>
          <div style={{ display: "flex", alignItems: "flex-start", width: "100%" }}>
            <Grid style={{ height: "100%", width: "93%" }}>
              <Grid sm={24}>
                <div style={{ width: "89vw", margin: "0 0rem" }}>
                  <ClientLookup
                    setSelectedClientId={getCustomerId}
                    parentRoute="add-filing-postaward"
                    checkForPostAward={true}
                  />
                </div>
              </Grid>

              <Grid sm={24}>
                <div
                  className="card"
                  style={{
                    width: "89vw",
                    padding: "0.1rem",
                    margin: "0 1rem",
                    background: tokens.colors.offWhite,
                    borderRadius: "8px",
                    overflow: "visible",
                    border: "none",
                  }}
                >
                  <AddFilingPostAwardtable
                    selectedClientId={customerId}
                    setLoadingFlag={setLoadingFlag}
                    changeSelectedMasters={handleSelectedMastersChange}
                  />
                </div>
              </Grid>
            </Grid>

            <Grid
              sx={{
                height: "100%",
                width: "5%",
                position: "sticky",
                top: 10,
                alignSelf: "flex-start",
              }}
            >
              <div
                style={{
                  height: "100%",
                  background: "transparent",
                  marginTop: "0",
                }}
              >
                <Item
                  sx={{
                    height: "100%",
                    background: "transparent",
                    boxShadow: "none",
                    borderRadius: "50px",
                    overflow: "visible",
                  }}
                >
                  <DeferredToolbox
                    isLoading={isLoading}
                    displayHistory={displayHistory}
                    addComment={addComment}
                    trackerPage={displayClientFiling}
                  />
                </Item>
              </div>
            </Grid>
          </div>
        </Fragment>
      )}
      <DeferredHistory
        show={showHistory}
        dockAt="right"
        tracker={getCurrentSelectedMaster()?.filingId && getCurrentSelectedMaster()}
        activityHistory={activityHistory}
        handleClose={closeHistory}
      />
      <DeferedCommentsPA
        show={showComments}
        dockAt="right"
        draft={getCurrentSelectedMaster()}
        comments={comments}
        handleClose={closeComments}
      />
      <CustomDialog
        header="Info"
        visible={showAlert}
        onHide={closeAlert}
      >
        {alertMessage}
      </CustomDialog>
    </Fragment>
  );
}

export default AddFilingPostAwardlist;
